export default "__VITE_ASSET__a214d25e__"